<template lang="html">
  <div>
    <server-form
      v-slot="slotProps"
      :form-action="formAction"
      :form="form"
      :validate-from-start="true">

      <my360Input
        :form="form"
        :error-bag="slotProps.errors"
        :label="__('label_account_name')"
        :generic-error-msg="__('feedback_account_name')"
        :validation-name="__('label_account_name')"
        required
        autofocus
        prop="name"/>

      <my360Input
        :form="form"
        :error-bag="slotProps.errors"
        :label="__('label_account_email')"
        :generic-error-msg="__('feedback_account_email')"
        :validation-name="__('label_account_email')"
        required
        type="email"
        prop="email"/>

      <my360Input
        :form="form"
        :error-bag="slotProps.errors"
        :label="__('label_account_job_title')"
        :generic-error-msg="__('feedback_account_job_title')"
        :validation-name="__('label_account_job_title')"
        type="text"
        prop="default_position"/>

      <my360Select
        v-if="multilingual"
        :form="form"
        :error-bag="slotProps.errors"
        :label="__('label_account_language')"
        :generic-error-msg="__('feedback_account_job_title')"
        :validation-name="__('label_account_language')"
        :options="[{ value: 'en', label: 'English' }, { value: 'es', label: 'Español' }]"
        type="text"
        prop="lang"/>

      <div class="custom-control custom-checkbox mt-5">
        <input
          id="password_check"
          v-model="form.password_form_show"
          type="checkbox"
          class="custom-control-input"
          novalidate
          name="password_check">
        <label
          class="custom-control-label"
          for="password_check">{{ __('label_account_password_ask') }}
        </label>
      </div>

      <div
        v-if="form.password_form_show">
        <my360Input
          :form="form"
          :error-bag="slotProps.errors"
          :label="__('label_account_new_password')"
          :generic-error-msg="__('feedback_account_new_password')"
          :validation-name="__('label_account_new_password')"
          required
          min="6"
          autocomplete="new-password"
          type="password"
          prop="password"/>

        <my360Input
          :form="form"
          :error-bag="slotProps.errors"
          :label="__('label_account_new_password_confirm')"
          :generic-error-msg="__('feedback_account_new_password')"
          :validation-name="__('label_account_new_password')"
          required
          min="6"
          autocomplete="new-password"
          type="password"
          prop="password_confirmation"/>
      </div>

    </server-form>
  </div>
</template>
<script>
import formAction from '../mixins/formAction'
export default {
  name: 'UserProfile',

  mixins: [formAction],

  props: {
    user: {
      type: Object,
      required: true
    },

    multilingual: {
      type: Boolean,
      required: false,
      default: () => { return false }
    }
  },

  data () {
    return {
      form: {}
    }
  },

  mounted () {
    this.form = {
      ...this.user,
      ...this.form
    }
    if (this.my360FormOld.password_check) {
      this.form.password_form_show = true
    }
  }
}
</script>
